import { useContext } from "react";
import NonIdealNew from "../../common/NonIdealNew";
import { LanguageContext } from "../../../context/LanguageContext";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import { InnerWrapper, MainContainer, TitleAndActionBox } from "../../common";
import { UBButton } from "../../../Libraries";
import withObservables from "@nozbe/with-observables";
import SalePOSList from "../SaleBook/SalePOSList";
import { observerAllTransactionByBusinessCount } from "../../../database/helpers/pos_txns";
import { useAuthContext } from "../../../context/AuthContext";
import { PlayIcon } from "../../../assets/icons/icon";
import { observePOSByBusinessCount } from "../../../database/helpers/invoice";

const POSLayout = ({ transactionsCount }) => {
  const [I18n] = useContext(LanguageContext);
  const navigate = useNavigate();
  const { business } = useAuthContext();

  const handleAddPOSSale = () => {
    triggerLogEvent(analytics, "pos_create");
    navigate("/SaleBook");
  };

  const isNonIdeal = transactionsCount <= 0;
  return (
    <MainContainer fluid className="quickSalePage">
      <Grid container>
        <Grid item md={12}>
          <TitleAndActionBox
            data={{
              title: I18n.sale_pos,
              isTitleCase: false,
            }}
          >
            <UBButton
              onClick={handleAddPOSSale}
              id={"start pos"}
              className="ubPrimaryButton fontSize12 fontWeight400 textUppercase marginLeft12"
              title={I18n.start_pos}
            />
          </TitleAndActionBox>
          <InnerWrapper className={"innerWrapper newInnerWrapper"}>
            {isNonIdeal ? (
              <NonIdealNew
                title={I18n.sale_pos}
                subtitle={I18n.too_many_walk_ins_keep_them_smooth_with_pos}
                button1Title={"start_pos"}
                // button2Title={"watch_video"}
                onButton1Click={handleAddPOSSale}
                video_footer={{
                  title: I18n.start_pos,
                  onClick: handleAddPOSSale,
                }}
                prefixIconButtonTwo={
                  <PlayIcon width="18px" height="18px" fill="var(--blue500)" />
                }
                video_url={
                  "https://www.youtube.com/embed/KpMpGauNeDc?si=_xvfwB-A25WKNQO1"
                }
                videoTitle={I18n.sale_pos}
                videoSubtitle={I18n.too_many_walk_ins_keep_them_smooth_with_pos}
              />
            ) : (
              <SalePOSList
                business={business}
                transactionsCount={transactionsCount}
              />
            )}
          </InnerWrapper>
        </Grid>
      </Grid>
    </MainContainer>
  );
};

const enhance = withObservables([], () => ({
  transactionsCount: observePOSByBusinessCount(
    localStorage.getItem("business_id") || "",
  ),
}));

export default enhance(POSLayout);
